import React, { useEffect, useState } from 'react';
import { injectIntl, defineMessages } from 'react-intl';
import DropdownComp from 'components/Dropdown/Dropdown';
import classes from 'components/SourceDisplay/SourceDisplay.module.scss';

const messages = defineMessages({
  mediaDeviceUnavailable: { id: 'components.videoSettings.mediaDeviceUnavailable', defaultMessage: 'Device Unavailable' },
  mediaDeviceUnavailableForm: { id: 'components.videoSettings.mediaDeviceUnavailableForm', defaultMessage: 'The selected device is no longer available. Please reattach the device or select another option.' }
});

export interface Item {
  icon?: string;
  label: string;
  value: string;
}

interface Props {
  handleChange: (value: string) => void;
  intl: { formatMessage: Function };
  items: Item[] | Array<any>;
  label: string | object;
  testIdPrefix: string;
  value?: string;
}

const SettingDropdown = (props: Props) => {
  const [error, setError] = useState('');
  const { handleChange, intl, items, testIdPrefix, value } = props;
  const hasItems = !!items?.length;

  const options = hasItems ? items : [{ label: intl.formatMessage(messages.mediaDeviceUnavailable), value }];

  const onSelectItem = (optionValue: string) => {
    if (optionValue !== value) {
      handleChange(optionValue);
    }
  };

  useEffect(() => {
    if (hasItems) {
      setError('');
    } else {
      setError(intl.formatMessage(messages.mediaDeviceUnavailableForm));
    }
  }, [hasItems, intl]);

  const dropdownButton = (open: boolean) => (
    <div className={`${classes.videoSelect} ${open ? classes.openSelect : ''}`} data-testid={`${testIdPrefix}-dropdown`}>
      {options.find(option => option.value === value).label}
    </div>
  );

  const dropdownItems = () => (
    <ul className={classes.sourceMenu}>
      <span>{error}</span>
      {options.map((option, index) => (
        <span key={`device-${option.value}-${index}`} title={option.label} >
          <button
            onClick={() => onSelectItem(option.value)}
            data-testid={`${testIdPrefix}-dropdown-option`}
          >
            {option.label}
          </button>
        </span>
      ))}
    </ul>
  );

  return (
    <DropdownComp
      buttonComponent={dropdownButton(false)}
      openButtonComponent={dropdownButton(true)}
      menuComponent={dropdownItems()}
      dropdownClassName={classes.sourceDropdown}
    />
  );
};

export default injectIntl(SettingDropdown);
